export interface Shoutout {
    senderName: string;
    receiverName: string;
    message: string;
    createdAt: string;
}

export interface SendShoutoutPayload {
    receiverId: number;
    message: string;
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_SHOUTOUT_RECENT_URL = `${API_BASE_URL}/api/shoutout/recent`;

// Fetch recent recognitions from the API
export const getRecentShoutouts = async (): Promise<Shoutout[]> => {
    const response = await fetch(API_SHOUTOUT_RECENT_URL);
    if (!response.ok) {
        throw new Error("Failed to fetch recent shoutouts");
    }
    return response.json();
}

const API_SHOUTOUT_URL = `${API_BASE_URL}/api/shoutout`;

export const sendShoutout = async (payload: SendShoutoutPayload, token: string): Promise<any> => {
    const response = await fetch(API_SHOUTOUT_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to send shoutout");
    }
    return response.json();
}